export default {
	"reportGeneration": {
		"reportType": "报表类型"
	},
	"reportList": {
		"createReport": "创建报表",
		"loading": "生成中",
		"rangeDate": "日期范围"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/reportdownload/reportdownload.js